import React, { useState, useEffect } from 'react';
import { Fab } from '@mui/material';
import logowhatsapp from 'assets/images/logo-whatsapp.png';
import { useToast } from 'legacyfrontend/hooks/useToast';
import ErrorSnackbar from 'legacyfrontend/components/ErrorSnackbar';

const FloatingButtonGroup = ({ phoneNumber, businessPhoneNumber }) => {
  const [isMounted, setIsMounted] = useState(false);
  const { toastState, hideToast } = useToast();

  useEffect(() => {
    setIsMounted(true);
  }, []);

  const hasRegularWhatsApp = Boolean(phoneNumber && phoneNumber !== null && phoneNumber !== undefined && phoneNumber.trim() !== '');
  const hasBusinessWhatsApp = Boolean(businessPhoneNumber && businessPhoneNumber !== null && businessPhoneNumber !== undefined && businessPhoneNumber.trim() !== '');
  
  const finalPhoneNumber = hasRegularWhatsApp ? phoneNumber : (hasBusinessWhatsApp ? businessPhoneNumber : null);
  const isBusiness = !hasRegularWhatsApp && hasBusinessWhatsApp;
  
  if (!isMounted || !finalPhoneNumber) {
    return null;
  }

  const whatsappUrl = isBusiness 
    ? `https://wa.me/${finalPhoneNumber}` 
    : `https://api.whatsapp.com/send/?phone=${finalPhoneNumber}`;

  return (
    <div className="fixed bottom-4 right-4 z-[99999999]">
      <Fab
        component="a"
        href={whatsappUrl}
        target="_blank"
        rel="noopener noreferrer"
        aria-label={isBusiness ? "Contactar por WhatsApp Business" : "Contactar por WhatsApp"}
        sx={{
          backgroundColor: '#25D366',
          transition: 'transform 0.2s ease-in-out',
          '&:hover': {
            backgroundColor: '#25D366',
            transform: 'translateY(-4px)',
          }
        }}
      >
        <img 
          alt={isBusiness ? "Icono de WhatsApp Business" : "Icono de WhatsApp"} 
          src={logowhatsapp} 
          style={{ width: 32, height: 32 }} 
        />
      </Fab>

      <ErrorSnackbar
        open={toastState.open}
        message={toastState.message}
        severity={toastState.severity}
        onClose={hideToast}
      />
    </div>
  );
};

export default FloatingButtonGroup;
